import Vue from 'vue';
import VueResource from 'vue-resource';
import moment from 'moment';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

function normalizarFiltros(filtros) {
  const parametros = Object.assign({}, filtros);

  const periodo = parametros.periodo;
  delete parametros.periodo;

  if (periodo && periodo[0] && periodo[1]) {
    parametros.dataInicio = moment(periodo[0]).format('MM/DD/YYYY');
    parametros.dataFim = moment(periodo[1]).format('MM/DD/YYYY');
  }

  return parametros;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({ pagina }, normalizarFiltros(filtros));

    return Vue.http.get('/api/liberarpagamento', { params: parametros }).then(response => response.data);
  },
  detalhe: idLancRateioCrypt => {
    return Vue.http.get(`/api/liberarpagamento/${encodeURIComponent(idLancRateioCrypt)}/detalhe`)
      .then(response => response.data);
  },
  excel: filtros => {
    return Vue.http.get('/api/liberarpagamento/Excel',
      {
        params: normalizarFiltros(filtros),
        responseType: 'blob',
      })
      .then(response => {
        if (!response.body || response.body === '' || response.body.size === 0) return '';

        return salvarArquivo(response);
      });
  },
  liberar: (idLancRateioCrypt, selecionados) => {
    return Vue.http.put('/api/liberarpagamento/liberar', {
      idLancRateio: idLancRateioCrypt,
      selecionados: selecionados || [],
    }).then(response => response.data);
  },
  reprovar: (idLancRateioCrypt, selecionados, observacao) => {
    return Vue.http.put('/api/liberarpagamento/reprovar', {
      idLancRateio: idLancRateioCrypt,
      selecionados: selecionados || [],
      observacao: observacao || '',
    }).then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/liberar-pagamento/servico.js